export default [
    {
        path: '/market/sns',
        name: 'sns',
        component: () => import('@@/views/market/socialMedia'),
        meta: {
            title: '社交媒体',
            parent: '/market/sns',
            // parentId: 9742018,//显示二级菜单需要有parentId或者路由加上/static
        },
        children: [
            {
                path: 'publish',
                name: 'sns-publish',
                meta: { title: '内容发布', parent: '/market/sns/publish'},
                component: () => import('@@/views/market/socialMedia/publish/index.vue'),
            },
            {
                path: 'account',
                name: 'sns-account',
                meta: { title: '社交媒体绑定', parent: '/market/sns/publish'},
                component: () => import('@@/views/market/socialMedia/account/index.vue'),
            },
            {
                path: 'publish/add',
                name: 'sns-publish-add',
                meta: { title: '内容发布', parent: '/market/sns/publish' },
                component: () => import('@@/views/market/socialMedia/publish/add/index.vue'),
            },
            {
                path: 'analysis',
                name: 'sns-analysis',
                meta: { title: '数据监测', parent: '/market/sns/publish'},
                component: () => import('@@/views/market/socialMedia/analysis/index.vue'),
            },
            {
                path: 'analysis/pagedata',
                name: 'sns-analysis-pagedata',
                meta: { title: '数据监测', parent: '/market/sns/publish'},
                component: () => import('@@/views/market/socialMedia/analysis/pagedata.vue'),
            },
        ]
    },
];
